export default "__VITE_ASSET__DVKy5ptM__"